export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fBxc4AMP6lbBP.ca8ad134.woff2";